import { createBrowserRouter } from "react-router-dom";
import { Root } from "./root";
import { ErrorBoundary } from "./ErrorBoundary";
import { HomePage } from "@/app/HomePage";
import { PersonalDataPage } from "@/app/personal-data/PersonalDataPage";
import { TypeProductPage } from "@/app/type-product/TypeProductPage";
import { AddressInfoPage } from "@/app/address-info/AddressInfoPage";
import { PaymentInfoData } from "@/app/payment-data/PaymentInfoData";
import { ConfirmSMSPage } from "@/app/payment-data/sms/ConfirmSMSPage";
import { ConfirmationNewLine } from "@/app/confirmation/auto-debt/ConfirmationNewLine";
import { InvalidPage } from "@/app/not-available/InvalidPage";
import { OfertaExpress } from "@/app/oferta-express/OfertaExpress";
import { PlanActivation } from "@/app/plan-activation/PlanActivation";
import { PlanPage } from "@/app/planos/[id]/PlanPage";
import { ResumePage } from "@/app/retomada/[uuid]/ResumePage";
import { ShortFlowFinishOrder } from "@/app/short-flow-finish-order/ShortFlowFinishOrder";
import { ShortFlowPersonalData } from "@/app/short-flow-personal-data/ShortFlowPersonalData";
import { ShortConfirmSMS } from "@/app/short-flow-sms-confirmation/ShortConfirmSMS";
import { SmartPage } from "@/app/smart-page/SmartPage";
import { PersonalDataComplement } from "@/app/personal-data/complement/PersonalDataComplementPage";
import { PersonalDataTypeProductPage } from "@/app/personal-data/type-product/TypeProductPage";
import { AddressInfoUnknown } from "@/app/address-info/unknown/AddressInfoUnknown";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/address-info",
        element: <AddressInfoPage />,
      },
      {
        path: "/address-info/unknown",
        element: <AddressInfoUnknown />,
      },
      {
        path: "/confirmation/auto-debt",
        element: <ConfirmationNewLine />,
      },
      {
        path: "/not-available",
        element: <InvalidPage />,
      },
      {
        path: "/oferta-express",
        element: <OfertaExpress />,
      },
      {
        path: "/payment-data",
        element: <PaymentInfoData />,
      },
      {
        path: "/personal-data/complement",
        element: <PersonalDataComplement />,
      },
      {
        path: "payment-data/sms",
        element: <ConfirmSMSPage />,
      },
      {
        path: "/personal-data",
        element: <PersonalDataPage />,
      },
      {
        path: "/plan-activation",
        element: <PlanActivation />,
      },
      {
        path: "/planos/:id",
        element: <PlanPage />,
      },
      {
        path: "/retomada/:uuid",
        element: <ResumePage />,
      },
      {
        path: "/short-flow-finish-order",
        element: <ShortFlowFinishOrder />,
      },
      {
        path: "/short-flow-personal-data",
        element: <ShortFlowPersonalData />,
      },
      {
        path: "/short-flow-sms-confirmation",
        element: <ShortConfirmSMS />,
      },
      {
        path: "/smart-page",
        element: <SmartPage />,
      },
      {
        path: "/type-product",
        element: <TypeProductPage />,
      },
      {
        path: "personal-data/type-product",
        element: <PersonalDataTypeProductPage />,
      },
    ],
  },
]);
